import { watch } from 'vue';
import { userStore } from '/@/store/modules/user';

// 模块顶层 timer，让 hook 与 stopHealthPoll 共享
let timer: number | undefined;

function tick() {
  // 双守卫：任一为空都跳过（即使 watch 失效也安全）
  const id = userStore.getPageId;
  const token = userStore.getTokenState;
  if (!id || !token) return;
  userStore.loadPageHealth(id);
}

function start() {
  stop();
  tick();
  timer = window.setInterval(tick, 30_000);
}

function stop() {
  if (timer !== undefined) {
    window.clearInterval(timer);
    timer = undefined;
  }
}

/**
 * 外部显式停止轮询（登出场景由 stateGuard 调用，绕开 watch 时序问题）
 */
export function stopHealthPoll(): void {
  stop();
}

let registered = false;

export function useHealthPoll(): void {
  if (registered) return; // 防御：App.vue 只该调一次，但保险防重复注册
  registered = true;

  // 切换专页立即拉新
  watch(
    () => userStore.getPageId,
    (id) => {
      if (id) start();
    },
    { immediate: true },
  );

  // 登录后恢复（辅助路径，停轮询主路径在 stateGuard 显式 stopHealthPoll）
  watch(
    () => userStore.getTokenState,
    (token) => {
      if (token) start();
    },
  );

  // 标签可见性
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') start();
    else stop();
  });

  // 关页清理
  window.addEventListener('beforeunload', stop);
}
